module.exports = __webpack_public_path__ + "img/badger.d1e46e09.png";